<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs :active-tab.sync="active_tab">


              <CTab title="کارتابل جدید">
                <AddSaleCartable :selectedType="3" :key="invoice_key"/>
              </CTab>
              <CTab title="لیست کارتابل ها">
                <SellCartableList/>
              </CTab>

              <CTab :title="$t('factorLists')">
<!--                <SellDocumentListFinal/>-->
              </CTab>


            </BTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
var items = [];
import BTabs from "../../tabs/BTabs";

import AddSaleCartable from "./AddSaleCartable.vue";
import SellCartableList from "./SellCartableList.vue";
export default {
  name: 'Login',
  components: {
    BTabs,
    AddSaleCartable,
    SellCartableList
    // SellDocumentListPreOrders,
    // SellCreditDocumentList
  },
  data() {
    return {

      active_tab:parseInt(localStorage.getItem("sale_factors_active_tab",0)),
invoice_key:0,

    }
  }, mounted() {

    bus.$on('reload_invoice_component', (data) => {
      // alert(data);
      this.invoice_key++;
    });
  }, watch: {
    'active_tab': function () {
      localStorage.setItem("sale_factors_active_tab",this.active_tab)
    },

  },
  methods: {



  }
}

</script>
